<app-general-header></app-general-header>

<div class="container blog">
  <header class="header-title">{{listHeader$ | async}}</header>
  <rt-loading [while]="loading$ | async">
    @if (list$ | async; as list) {
      <div>
        @for (item of list; track item?.id) {
          <div class="blog-entry">
            <div class="d-sm-flex">
              <div class="blog-img-wrapper flex-1">
                <a routerLink="{{item.url}}">
                  @if (item.thumbnail) {
                    <img class="blog-thumbnail" src="{{item.thumbnail['url']}}">
                  }
                </a>
              </div>
              <div class="blog-entry-main flex-1">
                @for (category of item.categories; track category?.id) {
                  <a class="blog-category">{{category.name}}</a>
                }
                <h3 class="blog-title"><a routerLink="{{item.url}}">{{item.title}}</a></h3>
                <div class="blog-date">{{item.date_obj | date:"longDate"}}</div>
                <div [innerHtml]="item['intro_html']"></div>
                <div class="read-more">
                  <a class="b-button b-button--light" routerLink="{{item.url}}">Read More</a>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </rt-loading>
</div>

<app-explore-your-brain callToActionButtonLink="/dashboard"></app-explore-your-brain>

<app-footer></app-footer>
